import { Component, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { SpinnerComponent } from '../shared/spinner/spinner.component';
import { Environment } from '../../config/environment';
import { AnalyticsBean } from 'src/app/beans/analytics/analytics-module.bean';
import { ActivatedRoute, Router } from '@angular/router';
import { EheAnalyticsDirective } from '../shared/ehe-analytics/ehe-analytics.directive';
import { DataCarrierService } from '../../services/core/data-carrier.service';
import { ProfileService } from 'src/app/services/core/profile.service';
import { HealthMentorService } from 'src/app/services/health-mentor/health-mentor.service';
import { APP_USER_PERMISSIONS } from 'src/app/constants/app-user-permissions.constants';
import { AuthService } from 'src/app/services/core/auth.service';

@Component({
	selector: 'app-health-mentor',
	templateUrl: './health-mentor.component.html',
	styleUrls: ['./health-mentor.component.scss'],
	providers: [EheAnalyticsDirective],
})
/**
 * Health Coach Component
 */
export class HealthMentorComponent implements OnInit {
	@ViewChild('sidenav') sidenav;

	userName: String;
	analyticsData: AnalyticsBean;

	eligibleForPE: boolean;
	eligibleForHM: boolean = false;
	hasFutureConfirmedAppt: boolean = false;

	showHealthMentorAppointmentTile: boolean = false;
	isMobileView: boolean = false;
	displayStatusBar: boolean = false;
	moduleLevel = APP_USER_PERMISSIONS;

	@HostListener('window:resize') onResize() {
		this.updateIsMobileView();
	}

	updateIsMobileView(): void {
		if (window.innerWidth < 800) {
			this.isMobileView = true;
		} else {
			this.isMobileView = false;
		}
	}

	/**
	 * Constructor of Health coaching component
	 * @param spinner - spinner component
	 * @param environment -  environment file that supplies env values
	 * @param router - angular router
	 * @param activatedRoute - activated route to fetch route details
	 * @param eheAnalyticsDirective - analytics directive
	 */
	constructor(
		private environment: Environment,
		private router: Router,
		private dataCarrierService: DataCarrierService,
		private profileService: ProfileService,
		private healthMentorService: HealthMentorService,
		private renderer: Renderer2,
		private spinner: SpinnerComponent,
		private activatedRoute: ActivatedRoute,
		private readonly authService: AuthService
	) {
		this.analyticsData = new AnalyticsBean();
		this.analyticsData.componentName = 'health-mentor';
		this.analyticsData.pageUrl = '/health/mentor';
		this.updateIsMobileView();
	}

	/**
	 * Component initialization - fetches upcoming pe appointments, coaching info and initializes messaging form
	 */
	ngOnInit() {
		this.profileService.getProfileInfo().subscribe(async (response: any) => {
			const profileInfo = response;
			this.dataCarrierService.pushValue('profile', profileInfo);
			// redirecting catalent clients from health coaching page to dashboard
			const profile = this.dataCarrierService.getChannel().getValue().profile;
			this.userName = profile.profileInfo.firstName;
			this.eligibleForPE = profile.profileInfo.eligibleForPE;

			this.activatedRoute.queryParams.subscribe(params => {
				if (params.q) {
					let queryParams = atob(params['q']);

					if (queryParams == 'hc-appt-confirmation') {
						this.showHealthMentorAppointmentTile = true;
						this.displayStatusBar = false;
					}
				}
			});

			if (profile && profile.profileInfo != null) {
				if (profile.profileInfo.client.id === this.environment.getEnvironment().CATALENT_CLIENTS) {
					this.router.navigate(['/dashboard']);
				}
			} else {
				if (
					response &&
					response.profileInfo &&
					response.profileInfo.client &&
					response.profileInfo.client.id == this.environment.getEnvironment().CATALENT_CLIENTS
				) {
					this.router.navigate(['/dashboard']);
				}
			}
			this.getHMInfo();
			this.getHMApptDetails();
			this.spinner.stopLoader();
		});
	}

	ngOnDestroy() {
		// Ensure the class is removed if the component is destroyed while sidenav is open
		this.renderer.removeClass(document.body, 'lock-scroll');
	}

	getHMInfo() {
		this.healthMentorService.getHealthMentorInfo().subscribe(
			data => {
				if (data.body) {
					this.eligibleForHM = data.body.canBook && data.body.coachingStatus;
				}
			},
			err => {
				console.log('getHMInfo Error', err);
			}
		);
	}

	getHMApptDetails() {
		this.healthMentorService.getMentorAppointments().subscribe(
			res => {
				this.hasFutureConfirmedAppt = res.hasFutureConfirmedAppt;
			},
			err => {
				console.log('getHMApptDetails Error', err);
			}
		);
	}
}
